import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useSignInDialog } from '../context/SignInDialogContext';
import EnterpriseAIClip from '../components/EnterpriseAIClip';

const Hero = () => {
  const { open: openSignIn } = useSignInDialog();
  return (
    <section className="relative overflow-hidden bg-black">
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.5] pointer-events-none"
        style={{
          backgroundImage:
            'linear-gradient(to right, rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.05) 1px, transparent 1px)',
          backgroundSize: '48px 48px',
          maskImage: 'radial-gradient(ellipse at top, black 30%, transparent 75%)',
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(60% 50% at 20% 10%, rgba(59,130,246,0.22), transparent), radial-gradient(50% 50% at 90% 30%, rgba(255,255,255,0.06), transparent)',
        }}
      />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-24 lg:pt-28 lg:pb-32">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-neutral-900 border border-neutral-800 mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-gradient-to-r from-white to-blue-500" />
              <span className="text-[12px] font-medium text-neutral-300">Introducing unified agentic platform</span>
            </div>
            <h1 className="text-[36px] sm:text-[48px] md:text-[58px] lg:text-[78px] leading-[1.02] sm:leading-[0.95] tracking-[-0.03em] font-semibold text-white">
              Industrialize <br />
              <span className="italic font-light brand-gradient-text">Enterprise AI.</span>
            </h1>
            <p className="mt-6 text-[17px] lg:text-[18px] text-neutral-300 leading-relaxed max-w-xl">
              The MetaxuOne Platform gives Enterprise AI the operational context it needs to succeed,
              so you can transform your operations and drive measurable value.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Button
                onClick={() => openSignIn('signin')}
                className="h-12 px-6 rounded-full bg-white hover:bg-neutral-200 text-neutral-950 text-[14px] font-medium inline-flex items-center gap-2"
                data-testid="hero-go-to-platform-btn"
              >
                Go to Platform <ArrowRight className="w-4 h-4" />
              </Button>
            </div>
            <div className="mt-10 flex items-center gap-6">
              <div>
                <div className="text-[34px] font-semibold text-white leading-none">66%</div>
                <div className="text-[12px] text-neutral-400 mt-1">Increase in invoices processed through AI</div>
              </div>
              <div className="h-10 w-px bg-neutral-800" />
              <div>
                <div className="text-[34px] font-semibold text-white leading-none">85+</div>
                <div className="text-[12px] text-neutral-400 mt-1">Companies active on MetaxuOne Platform</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 relative">
            <EnterpriseAIClip />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
